import React from 'react';
import BaseLayout from '@/components/layouts/BaseLayout';

const AboutPage: React.FC = () => {
  return (
    <BaseLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">About Us</h1>
          
          <div className="prose prose-lg">
            <p className="text-xl text-gray-600 mb-6">
              Welcome to Dental Health Blog, your trusted source for dental health information and professional advice.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Mission</h2>
            <p className="text-gray-600 mb-6">
              Our mission is to provide accurate, up-to-date information about dental health and wellness.
              We believe that everyone deserves access to reliable dental health information to make informed
              decisions about their oral care.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Team</h2>
            <p className="text-gray-600 mb-6">
              Our team consists of experienced dental professionals, health writers, and researchers who are
              passionate about sharing their knowledge and expertise. We work together to ensure that all
              content is accurate, evidence-based, and easy to understand.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Our Content</h2>
            <p className="text-gray-600 mb-6">
              We cover a wide range of topics related to dental health, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6">
              <li>Preventive dental care</li>
              <li>Common dental procedures</li>
              <li>Oral hygiene tips</li>
              <li>Dental health news and research</li>
              <li>Expert interviews and advice</li>
            </ul>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default AboutPage; 